namespace RioERP.Products {
    export interface ProductFranchiseeShareForm {
        ProductId: Serenity.LookupEditor;
        FranchiseeId: Serenity.LookupEditor;
        ESharingType: Serenity.EnumEditor;
        SharingAmount: Serenity.DecimalEditor;
    }

    export class ProductFranchiseeShareForm extends Serenity.PrefixedContext {
        static formKey = 'Products.ProductFranchiseeShare';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductFranchiseeShareForm.init)  {
                ProductFranchiseeShareForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.EnumEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(ProductFranchiseeShareForm, [
                    'ProductId', w0,
                    'FranchiseeId', w0,
                    'ESharingType', w1,
                    'SharingAmount', w2
                ]);
            }
        }
    }
}
